import { createEvent } from 'effector';
import { $aiAgentCategories } from './ai-agent-categories-store';

export const aiAgentCategoriesSetSelectedIdEvent = createEvent<string>();

$aiAgentCategories.on(aiAgentCategoriesSetSelectedIdEvent, (state, selectedId) => ({
  ...state,
  selectedId,
}));
